<template>
  <div class="intel"
       id="intelligenttop">
    <Topper></Topper>
    <div class="nei_tit">
      <img src="../assets/Intelligent_tit.jpg"
           alt="">
      <span>产业智能</span>
    </div>
    <!-- 业务介绍 -->
    <div class="nei_jieshao"
         style="height:11rem;">
      <h2>产业智能介绍 </h2>
      <p>面向智能时代，新奥积极推动智能化转型，以“品质化、低碳化、智能化”的家庭和企业客户需求为牵引，建设打造了智能生产和运营平台恩牛网，以及好气网、泛能网、聚安网、智购、来康网、嗯噢哇等产业智能平台，聚焦物联传感、大模型、机器人等智能技术，打造“感知、认知、行为”一体化的智能。</p>
      <img src="../assets/Intelligent_jgt.png"
           alt=""
           style="width:9.5rem;">
    </div>

    <!-- 嗯牛网 -->
    <div class="nei_title ennew_logo"
         id="enw">
      <h3>基础能力认知平台</h3>
      <h4>恩牛网</h4>
    </div>
    <div class="nei_img">
      <img src="../assets/enw.jpg"
           alt="">
    </div>
    <div class="nei_con">
      <p>提供平台能力支撑生态各方打造智能<br />
        通过智能运营链接家庭和企业实现认知共智<br />
        让客户精明消费、企业精细运营、需供精准匹配</p>
      <a href="https://www.ennew.com/">
        <div class="arrow_btn animate__animated animate__fadeInLeft animate__infinite"></div>
      </a>
    </div>

    <!-- 新智感知 -->
    <div class="nei_title xzgz_logo"
         id="xzgz">
      <h3>智能生产的数字基石</h3>
      <h4>新智感知</h4>
    </div>
    <div class="nei_img">
      <img src="../assets/xzgz.jpg">
    </div>
    <div class="nei_con">
      <p>打造物联感知产业园区，建立“科研生态、产研生态、市场生态”三个生态集群，通过生态整合打通产业链，打造物联感知产业的聚集地。</p>
      <p>公司坚持研发生产智能感知产品为使命，提供端、边侧的感知产品和解决方案，为产业数智化升级提供端侧支撑。</p>
      <a href="https://www.ngsense-tech.com/">
        <div class="arrow_btn animate__animated animate__fadeInLeft animate__infinite"></div>
      </a>
    </div>

    <!-- 好气网 -->
    <div class="nei_title hqw_logo"
         id="hqw">
      <h3>天然气专业能力认知平台</h3>
      <h4>好气网</h4>
    </div>
    <div class="nei_img">
      <img src="../assets/hqw_a.jpg">
    </div>
    <div class="nei_con nei_con2">
      <p>以客户成功为牵引，智能化解天然气行业难题</p>
      <p>好气网作为天然气专业能力认知平台，以客户成功目标牵引，通过智能能力赋能工业企业、电厂等用气客户及城燃分销商、管网运营商、资源商、设施商等生态各方，化解行业难题，提升产业效能。</p>
      <a href="https://www.greatgas.cn/">
        <div class="arrow_btn animate__animated animate__fadeInLeft animate__infinite"></div>
      </a>
    </div>

    <!-- 泛能网 -->
    <div class="nei_title fnw_logo"
         id="fnw">
      <h3>能碳专业能力认知平台</h3>
      <h4>泛能网</h4>
    </div>
    <div class="nei_img">
      <img src="../assets/hqw_a.jpg">
    </div>
    <div class="nei_con nei_con2">
      <p>泛能网是新奥集团旗下新奥数能打造的能碳专业能力认知平台，泛能网从各类企业主体和岗位角色的实际需求出发，实时采集荷源网储各环节的海量数据，利用数智技术，高效链接产业需求侧和供给侧，基于智能算法+泛能仿真+指数评价构成的泛能智能引擎工具，打造和应用一系列智能产品，从客户需求出发输出智能的、定制的、柔性的能碳一体化解决方案，数智赋能并联合产业生态各方共同落地，帮助各类终端用户达成安全经济高效用能与绿色低碳可持续发展，推动能源产业数智化升级、助力现代能源体系落地。</p>
      <a href="https://www.fanneng.com/">
        <div class="arrow_btn animate__animated animate__fadeInLeft animate__infinite"></div>
      </a>
    </div>

    <!-- 聚安网 -->
    <div class="nei_title jaw_logo"
         id="jaw">
      <h3>安全专业能力认知平台</h3>
      <h4>新智聚安</h4>
    </div>
    <div class="nei_img">
      <img src="../assets/jaw.jpg">
    </div>
    <div class="nei_con nei_con2">
      <p>新智聚安是新奥集团旗下专注安全智能的企业，依托新奥三十多年的燃气安全运营经验，融合物联网、大数据、AI等前沿技术，创新打造聚安网，以“智能+平台+生态”模式，为家庭、社区、企业、园区、政府等不同客户，提供一体化安全智能解决方案、产品和交付服务，助力实现城市本质安全。</p>
      <p>使命：让城市更安全 让人人更安心<br />
        愿景：成为值得信赖的安全专业能力认知平台<br />
        价值观：客户至上、始终创业、利他共生</p>
      <a href="https://www.juan.cn/">
        <div class="arrow_btn animate__animated animate__fadeInLeft animate__infinite"></div>
      </a>
    </div>

    <!-- 智购 -->
    <div class="nei_title zg_logo"
         id="zg">
      <h3>智能供应网络平台</h3>
      <h4>质信智购</h4>
    </div>
    <div class="nei_img">
      <img src="../assets/ygzc.jpg">
    </div>
    <div class="nei_con nei_con3">
      <p>智能供应网络平台</p>
      <p>质信智购致力于重构客创一体新型生产关系下的供应链体系，构建智能供应网络平台。聚焦满足客户个性化、品质化需求，为客创主体提供以寻源匹配、设计智能、工程管理等为核心的需智；以需求认知、品质呈现、智能排产交付等为核心的供智；以需供智能匹配、设计协同智能、交付协同等为核心的需供同智智能能力，赋能客创需供各方同智俱精。</p>
      <a href="https://zc.ygyg.cn/">
        <div class="arrow_btn animate__animated animate__fadeInLeft animate__infinite"></div>
      </a>
    </div>

    <!-- 来康网 -->
    <div class="nei_title lkw_logo"
         id="lkw">
      <!-- <h3>健康专业能力认知平台</h3> -->
      <h4>来康科技</h4>
    </div>
    <div class="nei_img">
      <img src="../assets/lkw_a.jpg">
    </div>
    <div class="nei_con nei_con2">
      <!-- <p>健康专业能力认知平台</p> -->
      <p>来康科技秉持“让天下人少生病”的使命，基于三济抑熵理论基础，致力于打造健康专业智能、驱动健康生活方式、升级健康产业协同模式。<br />
        围绕家庭健康需求，将健康智伴产品融入家庭生活，从身心灵全面认知家庭用户健康状态，提供一站式、个性化的健康服务，呵护家人健康。<br />
        依托生命熵智能仿真，打造健康专业智能模型，统一健康能力语言，实现需供顺畅沟通，以需供同智模式驱动健康产业能力智能化升级。</p>
      <a href="https://ennovalife.com/eow_03280956_225">
        <div class="arrow_btn animate__animated animate__fadeInLeft animate__infinite"></div>
      </a>
    </div>

    <!-- 嗯噢哇 -->
    <div class="nei_title eow_logo"
         id="eow">
      <h3>旅游专业能力认知平台 </h3>
      <h4>嗯噢哇</h4>
    </div>
    <div class="nei_img">
      <img src="../assets/eow.jpg">
    </div>
    <div class="nei_con nei_con4">
      <!-- <p>旅游专业能力认知平台</p> -->
      <p>嗯噢哇是新绎生活旗下专注于旅游场景的专业能力认知平台，以“能力化”视角重构旅游产业价值链，平台以构建“需供同智” 的全新产业模式为核心，为游客提供精准匹配的个性化体验，为商家及目的地运营者搭建智能获客、随需服务、高效运营的全链路体系，重新定义“所想即所得”的智能旅行生活新范式。</p>
      <a href="https://www.enowa.cn/">
        <div class="arrow_btn animate__animated animate__fadeInLeft animate__infinite"></div>
      </a>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import Topper from "./Topper";
import Footer from './Footer.vue';
export default {
  components: {
    Topper,
    Footer
  },
  name: "intelligent",
  data () {
    return {
    };
  },
  methods: {
    loadUrl () {
      //跳锚点
      let maodian = this.$route.params.maodian;
      console.log(maodian);
      if (maodian) {
        this.$nextTick(() => {
          const targetElement = document.querySelector(maodian);
          window.scrollTo({ top: targetElement.offsetTop - 45, behavior: 'smooth' });
        })
      } else {
        window.scrollTo(0, 0);
      }
    }
  },
  mounted () {

    this.loadUrl();
  }
};
</script>

<style scoped>
.intel {
  background: #f1f2f6;
  width: 750px;
  height: auto;
  overflow: hidden;
}
.nei_tit {
  width: 750px;
  height: 450px;
  position: relative;
  margin-top: 95px;
}
.nei_tit img {
  width: 750px;
  height: 450px;
  position: absolute;
  left: 0;
  top: 0;
}
.nei_tit span {
  position: absolute;
  left: 40px;
  top: 200px;
  font-size: 48px;
  color: #fff;
  font-weight: 500;
}
h2 {
  font-size: 36px;
  color: #1d2129;
  display: block;
  padding: 60px 40px 30px 40px;
  width: 670px;
  text-align: left;
  float: left;
}
p {
  font-size: 28px;
  color: #323233;
  width: 670px;
  text-align: left;
  padding: 10px 40px;
  float: left;
}
.nei_jieshao {
  width: 750px;
  height: 440px;
  background: url(../assets/introduce_bg.jpg);
  background-size: 100% 100%;
}

.nei_title {
  width: 670px;
  height: 90px;
  float: left;
  background: #fff;
  padding: 40px;
}
.nei_title h3 {
  font-size: 30px;
  height: 40px;
  line-height: 40px;
  color: #003f84;
  text-align: left;
  width: 100%;
  display: block;
  float: left;
}
.nei_title h4 {
  font-size: 36px;
  height: 50px;
  line-height: 50px;
  color: #1d2129;
  text-align: left;
  width: 100%;
  display: block;
  float: left;
}
.ennew_logo {
  background: #fff url(../assets/ennew_logo.png) 525px 45px no-repeat;
  background-size: 178px 70px;
}
.xzgz_logo {
  background: #fff url(../assets/xzgz_logo.png) 585px 45px no-repeat;
  background-size: 117px 96px;
}
.hqw_logo {
  background: #fff url(../assets/haoqiwang_logo.png) 500px 45px no-repeat;
  background-size: 194px 70px;
}
.fnw_logo {
  background: #fff url(../assets/fanneng_logo.png) 530px 45px no-repeat;
  background-size: 177px 70px;
}
.jaw_logo {
  background: #fff url(../assets/juan_logo.png) 510px 45px no-repeat;
  background-size: 198px 70px;
}
.zg_logo {
  background: #fff url(../assets/zczg_logo.png) 490px 55px no-repeat;
  background-size: 224px 50px;
}
.lkw_logo {
  background: #fff url(../assets/laikang_logo.png) 540px 55px no-repeat;
  background-size: 163px 60px;
}
.eow_logo {
  background: #fff url(../assets/enaowa_logo.png) 520px 55px no-repeat;
  background-size: 180px 70px;
}
.nei_img,
.nei_img img {
  width: 750px;
  height: 400px;
  float: left;
}
.nei_con {
  background: #013b78 url(../assets/energy_dotbg2.png) right bottom no-repeat;
  background-size: 529px 370px;
  padding: 40px;
  float: left;
  width: 670px;
  height: auto;
  overflow: hidden;
}
.nei_con2 {
  background: #0067ca url(../assets/energy_dotbg2.png) right bottom no-repeat;
  background-size: 529px 370px;
}
.nei_con3 {
  background: #c7520a url(../assets/energy_dotbg2.png) right bottom no-repeat;
  background-size: 529px 370px;
}
.nei_con4 {
  background: #00007f url(../assets/energy_dotbg2.png) right bottom no-repeat;
  background-size: 529px 370px;
}
.nei_con p {
  color: #fff;
  font-size: 28px;
  padding-left: 0;
}

.arrow_btn {
  width: 100px;
  margin-right: 430px;
  height: 60px;
  float: left;
  background: url(../assets/arrow_white.png) left center no-repeat;
  background-size: 34px 27px;
  margin-top: 40px;
  margin-left: 80px;
}
</style>
